import { CommonModule } from '@angular/common';
import { Component, Input, EventEmitter, Output } from '@angular/core';
import { ButtonComponent } from '@finder/shared/components/button/button.component';

@Component({
    selector: 'finder-no-results',
    templateUrl: './no-results.component.html',
    styleUrls: ['./no-results.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ButtonComponent,
    ]
})
export class NoResultsComponent {

    @Input() labels: any;
    @Output() clearAll: EventEmitter<boolean> = new EventEmitter<boolean>(false);

    clearAllFilters() {
        this.clearAll.emit(true);
    }
}
